import { Photo, PhotoProps } from "components/Photo";
import CarIcon from "assets/icons/car.svg";

export const CarPhoto = (props: Omit<PhotoProps, "type">) => (
  <Photo Icon={CarIcon} {...props} />
);
